<nav class="mt-2">
  <perfect-scrollbar
    style="position: relative"
    [config]="{}"
    [scrollIndicators]="true"
  >
    <div style="padding: 0px; margin: 0; height: auto; margin-bottom: 100px">
      <ul
        class="nav nav-pills nav-sidebar flex-column nav-flat"
        data-widget="treeview"
        role="menu"
        data-accordion="false"
      >
        <ng-container *ngFor="let item of menuItems">
          <ng-container
            *ngTemplateOutlet="sidebarInner; context: { item: item }"
          ></ng-container>
        </ng-container>
      </ul>
    </div>
  </perfect-scrollbar>
</nav>

<ng-template #sidebarInner let-item="item">
  <li
    *ngIf="isMenuItemVisible(item)"
    class="nav-item"
    [class.menu-open]="!item.isCollapsed"
    [class.has-treeview]="item.children"
  >
    <a
      *ngIf="item.route && item.route.indexOf('http') != 0"
      class="nav-link"
      [routerLink]="item.route"
      [class.active]="item.isActive"
      [ngClass]="{ 'active-color': item.isActive }"
      [style.width]="!sidebarExpanded ? '94%' : '60%'"
      [style.margin-left]="!sidebarExpanded ? '0' : '6px'"
    >
      <i class="nav-icon icon {{ item.icon }}"></i>
      <p class="pr-3" *ngIf="!sidebarExpanded">
        {{ item.label }}
      </p>
      <i
        *ngIf="
          item.label == 'Currículo' &&
          candidatoDto &&
          (candidatoDto.curriculoDadoPessoal == undefined || exibirAvisoDados())
        "
        class="fa-sharp fa-solid fa-triangle-exclamation text-orange"
      ></i>
    </a>

    <a
      *ngIf="item.route && item.route.indexOf('http') == 0 && !item.children"
      class="nav-link"
      target="_blank"
      [href]="item.route"
    >
      <i class="nav-icon icon {{ item.icon }}"></i>
      <p class="pr-3" *ngIf="!sidebarExpanded">
        {{ item.label }}
      </p>
      <i
        *ngIf="
          item.label == 'Currículo' &&
          candidatoDto &&
          (candidatoDto.curriculoDadoPessoal == undefined || exibirAvisoDados())
        "
        class="fa-sharp fa-solid fa-triangle-exclamation text-orange"
      ></i>
    </a>
    <a
      *ngIf="!item.route && item.children"
      class="nav-link"
      href="javascript:;"
      [class.active]="item.isActive"
      (click)="item.isCollapsed = !item.isCollapsed"
    >
      <i class="nav-icon icon {{ item.icon }}"></i>
      <p class="pr-3" *ngIf="!sidebarExpanded">
        {{ item.label }}
        <i class="right fas fa-angle-left icon"></i>
      </p>
      <i
        *ngIf="
          item.label == 'Currículo' &&
          candidatoDto &&
          (candidatoDto.curriculoDadoPessoal == undefined || exibirAvisoDados())
        "
        class="fa-sharp fa-solid fa-triangle-exclamation text-orange"
      ></i>
    </a>
    <ul
      *ngIf="item.children"
      class="nav nav-treeview"
      [collapse]="item.isCollapsed"
      [isAnimated]="true"
    >
      <ng-container *ngFor="let item of item.children">
        <ng-container
          *ngTemplateOutlet="sidebarInner; context: { item: item }"
        ></ng-container>
      </ng-container>
    </ul>
  </li>
</ng-template>
